import { ProductType } from "../../../../common/interfaces/enums/ProductType";
import IApiMortgageClient from "../../../interfaces/api/group/case/config/clients/IApiMortgageClient";
import { IApiGroupCaseConfig } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfig";
import { IApiGroupCaseConfigMortgage } from "../../../interfaces/api/group/case/config/IApiGroupCaseConfigMortgage";
import { IApiGroupCaseMortgage } from "../../../interfaces/api/group/case/IApiGroupCaseMortgage";
import { IClient } from "../../../../common/interfaces/IClient";
import ISettingClientMortgage from "../../../../common/interfaces/settings/clients/ISettingClientMortgage";
import { IQuoteSettingContainerMortgage } from "../../../../common/interfaces/settings/IQuoteSettingContainerMortgage";
import { IQuoteSettingsContainerBase } from "../../../../common/interfaces/settings/IQuoteSettingsContainerBase";
import EnumMapper from "../EnumMapper";
import { Client } from "./BaseClientMapper";

import {
    assembleMapper,
    localToRemoteMapper,
    remoteToLocalMapper
} from "./SettingMapper";

const mapRemoteClientToLocal = (
    clients: IApiMortgageClient[]
): ISettingClientMortgage[] => {
    return clients.map((client) => {
        return {
            ...Client.remoteToLocal(client),
            employmentType: EnumMapper.EmploymentType.remoteToLocal(
                client.employmentType
            ),
            monthlyCover: client.monthlyCover,
            income: client.income,
            occupation: client.occupation,
            occupationClass: client.occupationClass.toString(),
            paymentPeriod: EnumMapper.PaymentPeriod.remoteToLocal(client.paymentPeriod),
            waitPeriodWeeks: client.waitPeriodWeeks
        };
    });
};

const mapRemoteSettingToLocal = (
    baseSettings: IQuoteSettingsContainerBase,
    extension: IApiGroupCaseMortgage
): IQuoteSettingContainerMortgage => {
    return {
        ...baseSettings,
        clients: mapRemoteClientToLocal(extension.clients),
        allowChildren: false,
        productType: ProductType.Mortgage,
        mortgageAmount: extension.mortgageAmount,
        repaymentAmount: extension.repaymentAmount,
        repaymentFrequency: EnumMapper.PaymentFrequency.remoteToLocal(
            extension.mortgageRepaymentFreq
        )
    };
};

const mapLocalSettingToRemote = (
    baseSetting: IApiGroupCaseConfig,
    extension: IQuoteSettingContainerMortgage,
    clients: IApiMortgageClient[]
): IApiGroupCaseConfigMortgage => {
    return {
        ...baseSetting,
        clients,
        mortgageAmount: extension.mortgageAmount,
        repaymentAmount: extension.repaymentAmount,
        repaymentFrequency: extension.repaymentFrequency
    };
};

const mapLocalClientToRemote = (
    client: IClient,
    setting: IQuoteSettingContainerMortgage
): IApiMortgageClient => {
    const settingClient = setting.clients.find((c) => c.personId === client.personId);

    return {
        ...Client.localToRemote(client),
        employmentType: settingClient.employmentType,
        income: settingClient.income,
        monthlyCover: settingClient.monthlyCover,
        occupation: settingClient.occupation,
        occupationClass: settingClient.occupationClass,
        paymentPeriod: settingClient.paymentPeriod,
        waitPeriodWeeks: settingClient.waitPeriodWeeks
    };
};

const remoteToLocal = (settings: IApiGroupCaseMortgage): IQuoteSettingContainerMortgage =>
    remoteToLocalMapper<IQuoteSettingContainerMortgage, IApiGroupCaseMortgage>(
        settings,
        mapRemoteSettingToLocal
    );

const localToRemote = (
    clients: IClient[],
    settings: IQuoteSettingContainerMortgage
): IApiGroupCaseConfigMortgage =>
    localToRemoteMapper(
        clients,
        settings,
        mapLocalSettingToRemote,
        mapLocalClientToRemote
    );

export default assembleMapper(remoteToLocal, localToRemote);
